// import React from 'react';
// import { useTrackingStatuses } from '../../hooks/useTrackingStatuses';
// import { Copy } from 'lucide-react';
// import { showToast } from '../../components/Toast';

// const TrackingFormatter = ({ trackingNumbers }) => {
//   const { statuses, loading } = useTrackingStatuses(trackingNumbers);

//   return (
//     <div className='d-flex justify-content-between align-items-center' style={{ width: '350px' }}>
//       <div>
//         {trackingNumbers.map((trackingNumber, index) => (
//           <div key={index}>
//             {trackingNumber} - {loading ? 'Loading...' : statuses[trackingNumber] || 'Unknown'}
//           </div>
//         ))}
//       </div>
//       <Copy
//         size={20}
//         color='#497ea7'
//         style={{ cursor: 'pointer' }}
//         onClick={(e) => {
//           e.stopPropagation();

//           const textToCopy = trackingNumbers.join(',\n');

//           if (navigator.clipboard && navigator.clipboard.writeText) {
//             navigator.clipboard
//               .writeText(textToCopy)
//               .then(() => {
//                 showToast('success', 'Copied to clipboard');
//               })
//               .catch(() => {
//                 showToast('error', 'Failed to copy tracking numbers.');
//               });
//           } else {
//             const textarea = document.createElement('textarea');
//             textarea.value = textToCopy;
//             textarea.style.position = 'fixed';
//             textarea.style.opacity = 0;
//             document.body.appendChild(textarea);
//             textarea.select();

//             try {
//               document.execCommand('copy');
//               showToast('success', 'Copied to clipboard');
//             } catch (err) {
//               showToast('error', 'Failed to copy tracking numbers.');
//             }

//             document.body.removeChild(textarea);
//           }
//         }}
//       />
//     </div>
//   );
// };

// export default TrackingFormatter;

const TrackingStatus = ({ trackingNumbers, trackingStatuses }) => {
  return (
    <div>
      {trackingNumbers.length > 0 ? (
        trackingNumbers.map((trackingNumber, index) => (
          <div key={index}>
            <strong>{trackingNumber}</strong> -<span className='status-text'>{trackingStatuses[trackingNumber] || 'Fetching...'}</span>
          </div>
        ))
      ) : (
        <span></span>
      )}
    </div>
  );
};

export default TrackingStatus;
